import { render, staticRenderFns } from "./WaitingMaintenance.vue?vue&type=template&id=0976ba54"
import script from "./WaitingMaintenance.vue?vue&type=script&lang=ts"
export * from "./WaitingMaintenance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports